var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fast Delivery ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M257.1,328.556a38.447,38.447,0,0,0-71.833-12.721,38.445,38.445,0,0,1,56.366,28.188H332V328.556Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.406,328.556a13.5,13.5,0,0,1-13.687-13.264V129.968h-1.78c-7.427,0-13.687,5.694-13.687,13.122V330.759a13.5,13.5,0,0,0,13.687,13.264h18.607a38.223,38.223,0,0,1,5.907-15.467Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.376,238h50a7,7,0,0,0,0-14h-50a7,7,0,1,0,0,14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.376,288a7,7,0,0,0,0-14h-70a7,7,0,1,0,0,14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.376,188h30a7,7,0,0,0,0-14h-30a7,7,0,0,0,0,14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,186.907v58.142a7,7,0,0,0,3.5,6.062l50.356,29.071a7,7,0,0,0,7,0l50.494-29.071A7.136,7.136,0,0,0,287,245.049V186.907a7.136,7.136,0,0,0-3.642-6.062l-50.424-29.071a7.063,7.063,0,0,0-7.035,0l-50.376,29.071A7.02,7.02,0,0,0,172,186.907Zm14,12.121,36,20.988V262l-36-20.988Zm43.363,8.864-11.67-6.738,36.349-20.986,11.67,6.737ZM236,262v-41.98l37-20.988v41.98Zm-6.637-96.077,10.679,6.166-36.349,20.986-10.679-6.166Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.6,239.249c-.008-.106-.019-.211-.032-.316-.015-.121-.034-.24-.055-.36s-.04-.217-.065-.324-.055-.226-.087-.338-.061-.216-.1-.322-.077-.218-.119-.326-.082-.208-.128-.31-.1-.209-.151-.313-.1-.2-.159-.3-.116-.2-.177-.291-.129-.2-.2-.294-.128-.175-.195-.261-.159-.2-.242-.292c-.038-.043-.071-.09-.111-.133l-51.517-56.229A27.16,27.16,0,0,0,411.372,170H338V147.63A26.63,26.63,0,0,0,311.1,121H147.624A26.4,26.4,0,0,0,121,147.63V329.37A26.4,26.4,0,0,0,147.624,356h25a7,7,0,1,0,0-14h-25A12.386,12.386,0,0,1,135,329.37V147.63A12.386,12.386,0,0,1,147.624,135H311.1A12.616,12.616,0,0,1,324,147.63V342H242.624a7,7,0,0,0,0,14h120a7,7,0,0,0,0-14H338V247H471v82.37c0,7.168-6.208,12.63-13.376,12.63h-25a7,7,0,0,0,0,14h25C472.512,356,485,344.257,485,329.37V239.8c0-.057-.195-.113-.2-.17C484.8,239.505,484.606,239.377,484.6,239.249ZM338,184h73.372a13.223,13.223,0,0,1,9.577,4.406L461.7,233H338Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.624,349.37a42,42,0,1,0,42-42A42.048,42.048,0,0,0,165.624,349.37Zm70,0a28,28,0,1,1-28-28A28.032,28.032,0,0,1,235.624,349.37Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.624,349.37a42,42,0,1,0,42-42A42.048,42.048,0,0,0,355.624,349.37Zm70,0a28,28,0,1,1-28-28A28.032,28.032,0,0,1,425.624,349.37Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.7a6ba1824fb444a142827af6fc1dbe84.svg";
export { ForwardRef as ReactComponent };